import React, { useEffect, useState } from 'react';
import { TextField, CircularProgress, styled } from '@mui/material';
import Autocomplete from '@mui/lab/Autocomplete';
import Api from '../../services/api';
import { getErrorMessage, getFieldProps } from '../../views/smart-kit/Form/gridFormUtils';
import { RtlTextField } from '../RTLTextField';

const RtlAutoComplete = styled(Autocomplete)({
  '& .MuiAutocomplete-endAdornment': {
    left: '2px !important',
    right: 'unset !important'
  },
  '& .MuiAutocomplete-inputRoot': {
    paddingRight: '12px !important'
  }
});

export default function SmartAutoComplete({
  path,
  label,
  value,
  onChange,
  render,
  error,
  disabled,
  defaultFilters = {}
}) {
  let initialValue = typeof render === 'string' ? { [render]: '' } : { name: '' };

  // console.log('defaultFilters', defaultFilters)
  if (typeof render === 'object' && render.length > 0) {
    let v = {};
    for (const key of render) {
      v[key] = '';
    }
    initialValue = v;
  }

  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      // console.log(path)

      const response = await Api.list(path, defaultFilters);
      // console.log(response.data)

      if (active && response.data && response.data.length > 0) {
        // console.log(response.data.map((d) => d[render]))
        setOptions(response.data);
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      // setOptions([])
    }
  }, [open]);

  useEffect(() => {
    // if (value) {
    if (value) {
      Api.list(path, defaultFilters).then((res) => {
        // console.log(res.data)
        setOptions(res.data);
        setSValue(res.data.filter((f) => f.uuid === value)[0]);
      });
    }

    // }
  }, [value]);

  const [sValue, setSValue] = useState(initialValue);

  const handleChange = (e, newValue) => {
    setSValue(newValue);
    // console.log(newValue)
    if (newValue && newValue.uuid) {
      onChange(newValue.uuid);
    } else {
      onChange(null);
    }
  };

  const getOptionLabel = (option) => {
    return typeof render === 'string'
      ? option[[render]]
      : typeof render === 'object' && render.length > 0
      ? render.map((r) => option[[r]]).join(' ')
      : option.name;
  };

  return (
    <RtlAutoComplete
      id="asynchronous-demo"
      // className="w-300"

      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={sValue}
      onChange={handleChange}
      getOptionSelected={(option, value) => option.uuid === value.uuid}
      getOptionLabel={getOptionLabel}
      options={options}
      loading={loading}
      disabled={disabled}
      // defaultValue={}
      renderInput={(params) => (
        <RtlTextField
          {...params}
          label="Asynchronous"
          fullWidth
          {...getFieldProps(label)}
          error={Boolean(error)}
          helperText={error && getErrorMessage(error)}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            )
          }}
        />
      )}
    />
  );
}
